import React from "react";
import { valueMapper } from "./ins-principles-mapper";
import { InsPrinciplesFooter } from "./insPrinciplesFooter";
import { InsPrinciplesSection } from "./insPrinciplesSection";
import styles from "./insUNGlobalCompactPrinciplesWidget.module.scss";
import { getPrincipleNumber, principlesIndexes } from "common/un-principles-helper";
import { InsWidget } from "components/widgets/base";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { InsWidgetTitle } from "components/widgets/base/widget-title/insWidgetTitle";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
const principlesWidgetLang = language.en.widgets.principlesTable;
export const InsUNGlobalCompactPrinciplesWidget = (props) => {
    const { widgetId, sectionId } = props;
    const descriptions = principlesWidgetLang.descriptions;
    const [[data], queryState] = useGetDatapointsWidgetData(props);
    const series = valueMapper(data?.data?.[0]?.series);
    const rowData = series?.map((item) => ({
        description: descriptions[item.principle.toLowerCase()],
        principle: `${principlesWidgetLang.principle} ${getPrincipleNumber(item.principle)}`,
        violationSource: item.violationSource,
        violationStatus: item.violationStatus
    }))
        ?.sort((a, b) => getPrincipleNumber(a.principle) - getPrincipleNumber(b.principle));
    const sectionsItems = [
        { category: principlesWidgetLang.humanRights, rowData: rowData.slice(0, principlesIndexes.humanRightsEndIndex) },
        { category: principlesWidgetLang.labour, rowData: rowData.slice(principlesIndexes.humanRightsEndIndex, principlesIndexes.labourEndIndex) },
        { category: principlesWidgetLang.environment, rowData: rowData.slice(principlesIndexes.labourEndIndex, principlesIndexes.environmentEndIndex) },
        { category: principlesWidgetLang.antiCorruption, rowData: rowData.slice(principlesIndexes.environmentEndIndex) }
    ];
    const sections = sectionsItems.map((item, index) => React.createElement(InsPrinciplesSection, { key: item.category, category: item.category, hasHeader: index === 0, rowData: item.rowData }));
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, showMaximize: true, content: React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(rowData.length > 0) },
            React.createElement("div", { className: styles.container }, sections)), footer: React.createElement(InsPrinciplesFooter, null), title: React.createElement(InsWidgetTitle, { ...props }) });
};
